import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Esto es solo otra dieta más?',
    a: 'No. No te pedimos que elimines grupos de alimentos ni que cuentes calorías. Te pedimos que añadas 10 ingredientes específicos preparados de una manera específica durante 7 días. La mayoría de personas come prácticamente lo mismo que siempre, simplemente añaden el protocolo.'
  }, {
    q: '¿Funciona para artritis reumatoide o solo para osteoartritis?',
    a: 'El protocolo aborda la inflamación crónica de bajo grado que está presente en ambas condiciones. Sin embargo, la artritis reumatoide es una enfermedad autoinmune que requiere supervisión médica. Consulta a tu médico antes de comenzar.'
  }, {
    q: '¿Cuánto tiempo tengo que seguirlo?',
    a: 'El protocolo intensivo son 7 días. Después hay una fase de mantenimiento simple que puedes seguir de por vida con muy poco esfuerzo y un costo de aproximadamente $12-15 dólares a la semana.'
  }, {
    q: '¿Y si no tengo tiempo de cocinar?',
    a: 'Las preparaciones más largas del protocolo toman 20 minutos. El caldo de huesos se hace solo mientras duermes. El Flush Matinal toma 2 minutos. La Pasta de Oro se prepara una vez y dura 2 semanas.'
  }, {
    q: '¿Por qué cuesta solo $7 si vale $34?',
    a: 'Porque nuestro objetivo en VitalyForms es que el precio nunca sea la razón por la que una mujer mayor de 55 años siga sufriendo dolor articular innecesariamente. Si funciona para ti, vas a recomendárselo a alguien más. Esa es nuestra estrategia de crecimiento.'
  }];
  return <section className="bg-cream py-24 px-6 md:px-12 lg:px-24" data-id="element-37">
      <div className="max-w-3xl mx-auto" data-id="element-38">
        <FadeIn data-id="element-39">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-center text-text-black mb-12" data-id="element-40">
            Preguntas que probablemente tienes:
          </h2>
        </FadeIn>

        <div className="space-y-4" data-id="element-41">
          {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-42">
              <div className="bg-white rounded-xl shadow-sm border border-gold-light overflow-hidden" data-id="element-43">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full text-left p-6 flex justify-between items-center focus:outline-none" data-id="element-44">
                  <span className="text-xl font-bold text-dark-green pr-8" data-id="element-45">
                    {faq.q}
                  </span>
                  <ChevronDown className={`text-gold flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} size={24} data-id="element-46" />
                </button>

                <AnimatePresence data-id="element-47">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-48">
                      <div className="p-6 pt-0 text-lg text-text-gray border-t border-gray-100" data-id="element-49">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}